import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"
import usePurchaseOrderForm from "@/screens/Procurement/PurchaseOrder/hooks/usePurchaseOrderForm"
import { isReadonlyStatus } from "@/screens/Procurement/PurchaseOrder/utils"

interface UsePurchaseOrderReadonlyReturn {
  isReadonly: boolean
  isStatusReadonly: boolean
  hasPermission: boolean
}

/**
 * Hook to determine if Purchase Order should be in read-only mode
 *
 * Returns true for readonly when:
 * - Status is Cancelled, Complete, or Quote Cancelled
 * - User lacks PURCHASE_ORDER_CREATION permission
 */
export const usePurchaseOrderReadonly = (): UsePurchaseOrderReadonlyReturn => {
  const { hasPermissions } = usePermissionManager()
  const { getField } = usePurchaseOrderForm()
  const status = getField("status")

  const isStatusReadonly = isReadonlyStatus(status)
  const hasPermission = hasPermissions([PermissionActionType.PURCHASE_ORDER_CREATION])
  const isReadonly = isStatusReadonly || !hasPermission

  return {
    isReadonly,
    isStatusReadonly,
    hasPermission,
  }
}
